const EN_CUSTOM = {
  accessToWifi: 'Have access to Wi-Fi at the charging location',
  AFTER_10PM_BEFORE_11AM: 'After 10pm; before 11am',
  AFTER_11AM_BEFORE_10PM: 'After 11am; before 10pm',
  AFTER_1230AM_BEFORE_930AM: 'After 12:30am; before 9:30am',
  AFTER_12PM_BEFORE_8PM: 'After 12pm; before 8pm',
  AFTER_2PM_BEFORE_6PM: 'After 2pm; before 6pm',
  AFTER_6AM_BEFORE_3PM: 'After 6am; before 3pm',
  AFTER_6PM_BEFORE_9AM: 'After 6pm; before 9am',
  AFTER_8AM_BEFORE_MN: 'After 8am; before midnight',
  AFTER_9PM_BEFORE_6AM: 'After 9pm; before 6am',
  AFTER_9PM_BEFORE_9AM: 'After 9pm; before 9am',
  AFTER_MN_BEFORE_8AM: 'After midnight; before 8am',
  'after.Incentives': 'AFTER INCENTIVES',
  agreeOffPeakSchedule: 'Agree to charge on an off-peak schedule',
  ALL_HOURS: 'All hours (unpredictable)',
  ATTACHED_GARAGE: 'Attached Garage',
  averageMonthlyCharge: 'AVERAGE MONTHLY CHARGE',
  averageMonthlyCharge_tool:
    'Select the amount of total electric charges (not including gas charges) on a typical monthly bill, regardless of season. We use this amount to estimate a baseline for your current energy consumption.',
  basement: 'Basement',
  basicFilters: 'Basic Filters',
  certifiedElectrician: 'Certified electrician',
  charger: 'CHARGER',
  chargeWithLevelTwoCharger:
    'Charge with an eligible Level 2 charger or drive an eligible electric vehicle',
  close: 'Close',
  'compareVehicles.carMake': 'Car Make',
  'compareVehicles.carModel': 'Car Model',
  'compareVehicles.fuelType': 'Fuel Type',
  ContactInformation: 'Contact Information',
  conventionalVehicleEfficiency: 'Conventional Vehicle Efficiency (mpg)',
  conventionalVehicleEfficiencyTooltip:
    'To calculate possible savings, enter the miles per gallon (MPG) of the gasoline vehicle that you want to replace with an all-electric or Plug-In Hybrid EV.',
  costOfPublicCharging: 'Cost of Public Charging',
  costOfPublicChargingTooltip:
    'We estimate the cost of paid public charging stations, but you can edit this filter if you know your local charging cost.',
  CountiesCovered: 'Counties Covered',
  currentPricingPlan: 'CURRENT PRICING PLAN',
  DETACHED_GARAGE: 'Detached Garage',
  driveEVOrPHEV: 'Drive an electric vehicle (all-electric or plug-in hybrid)',
  DRIVEWAY: 'Not in a Garage',
  DRParagraph1:
    'The standard DR pricing plan is based on the amount of electricity you\n            use, not when you use it. The less electricity you use, the less you pay\n            – any time, day or night.',
  DRParagraph2:
    'This plan can be a good fit for lower-use households and those that\n            prefer to save by conserving without thinking about the time of day.',
  egbBringCharger: 'I will use my own Level 2 charger',
  egbNeedCharger: 'I need a Level 2 charger',
  egbOurPrograms:
    'We have programs that make charging at home easier. If you need a Level 2 charger, our EV Accelerate At Home program could be a good fit for you.',
  'electricians.map.caption':
    'Are you a certified EV charging station installer in the San Diego area? Please contact {email} to be considered for inclusion in our database of certified electricians. The electricians listed on this site are not endorsed, sponsored or employed by SDG&E.',
  'electricians.subtitle':
    'Enter your zip code to find certified electricians in your area. Click on each result to view location and contact information.',
  'electricians.title': 'Certified Electricians',
  electricPortion: 'Electric Portion',
  'Energy Information Administration': 'Energy Information Administration',
  estimatedDIYCost: 'Estimated average DIY cost:',
  'ev.avg.range': 'Electric Range Average',
  'ev.carDetails.calc.chargingRate': 'Charging Rate',
  'ev.cardetails.calc.description': 'Description',
  'ev.carDetails.calc.electricityEmissionsMetric':
    'Electricity Emissions in CO2 kg/MWh',
  'ev.carDetails.calc.ev.cardetails.calc.electricityEmissions':
    'Electricity Emissions in CO2 lbs/MWh',
  'ev.carDetails.calc.kmDrivenPerYr': 'Kilometers Driven Per Year',
  'ev.cardetails.calc.source': 'Source',
  'events.both': 'In Person and Virtual',
  'events.nationwide': 'Nationwide',
  'evfilter.carTitle': 'EV Preference',
  evFuelType: 'All Electric',
  'evs.buttonMatchScoreAndFilters': 'Match Score and Filters',
  'evs.incentivesScoreOptions': 'Incentive Eligibility Filters',
  'evs.slideMilesDrivenDaily': 'Minimum Range',
  'evs.thirdParty':
    '*This website contains links to third-part external websites. SDGE does not endorse or accept any liability for  content or products sold on any third-party websites. Please be aware that this vehicle may not be available in your area.  Contact your local dealer to ensure availability. ',
  'evSort.chargerPower': 'Charger Power',
  feet: 'feet',
  filing_status_tooltip: 'Used to determine incentive eligibility.',
  fuel_tooltip: 'Select all vehicle body types you are interested in.',
  Finished: 'Finished',
  'footer.jdpDisclaimer':
    'Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither J.D. Power® nor SDGE provides tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction.',
  footerPhrase1: 'Rates and Regulations',
  footerPhrase10: 'Total Electric Rates',
  footerPhrase11: 'Customer Choice',
  footerPhrase2: 'Energy Data Request',
  footerPhrase3: 'Terms & Conditions',
  footerPhrase4: 'FERC Standards of Conduct - Order 717',
  footerPhrase5: 'Major Projects',
  footerPhrase6: 'Customer Service',
  footerPhrase7: 'CPUC Postings',
  footerPhrase8: 'Careers',
  footerPhrase9: 'Privacy Center',
  forInstallation: 'for installation',
  forLevelTwoCharger: 'for level 2 charger',
  forSeparateMeter: 'for separate meter',
  free: 'Free',
  garage: 'Garage',
  gasolinePrice: 'Gasoline Price',
  gasolinePriceInCentsPerGal_tooltip:
    'Enter your local gas price. Our default is based on your region’s most recent gas price, updated montly.',
  hcaCarCondition: 'CAR CONDITION',
  hcaCarMake: 'Car Make',
  hcaCarModel: 'Car Model',
  hcaChargerLocation: 'Charger Location',
  hcaCurrentElectricRate: 'Current Electric Rate',
  hcaCurrentMonthlyBill: 'Current Monthly Bill',
  hcaDistanceSliderLabel: 'Distance: Panel to Charging Location',
  hcaDistanceSliderLabelToolTip:
    'Consider that electrical circuits don’t usually run in a straight line between panel and charging location due to walls, floors, or outdoor space in between.',
  hcaElectricPanelLocation: 'Electric Panel Location',
  hcaIncludedEnergyCosts: 'INCLUDED ENERGY COSTS',
  hcaNewestModels: 'Newest Models',
  hcaOlderModels: 'Older Models',
  hcaPanelLocationRoomType: 'Panel Location Room Type',
  hcaPortionPublicCharging: 'Portion of Public Charging',
  hcaPortionPublicChargingTooltip:
    'EV drivers do almost all of their charging at home.',
  hcaPublicChargingCost: 'Public Charging Cost',
  hcaWhenWillYouCharge: 'When will you charge?',
  'header.cards.electricians': 'Find Certified Electricians',
  'header.cards.home-chargers': 'Shop Home Chargers',
  'header.cards.incentives': 'Search Incentives',
  'header.cards.rates': 'View Savings Calculator',
  'header.electricians': 'Electricians',
  'header.promise.cta': 'Start with Incentives',
  'header.promise.subtitle':
    'Estimate and compare EV costs, savings, incentives and more.',
  'header.promise.title': 'Get the most out of your EV.',
  'header.rates': 'Savings Calculator',
  high: 'High',
  'home.vehicleCarousel.browseAllEvs': 'Browse All EVs',
  'home.vehicleCarousel.compareEvs': 'Compare EVs',
  'home.vehicleCarouselSubTitle':
    'Compare your selection to a similar gas vehicle. An EV can save you\n            money because it can be cheaper to own and maintain than a 100%\n            gasoline-powered car.',
  'home.vehicleCarouselTitle':
    'There are more electric vehicles than ever. Discover yours.',
  homechargerChargerType: 'CHARGER TYPE',
  homechargerEvfilter: 'Basic Filters',
  'homechargers.caption':
    'The home chargers listed on this site are not manufactured or endorsed by SDG&E.',
  'homeChargers.disclaimer':
    'Charger manufacturers, want your charger featured here? Reach out to {email}.',
  'homeChargers.subtitle':
    'Find options for Level 2 EV chargers that fit your home needs and EV preferences. Adjust the filters to personalize your results.',
  'homepage.zipcode.disclaimer':
    'Personalized pricing plans in less than 1 minute. No signup required.',
  'homepage.zipcode.getStarted': 'Get Started',
  'homepage.zipcode.subtitle':
    'This tool will clearly identify the lowest cost EV pricing plan.',
  'homepage.zipcode.title':
    'Did you know that we offer a variety of electric pricing plans? Find the best EV pricing plan for you.',
  homeWiring: 'HOME WIRING',
  household_income_tooltip:
    'Combine income from all household members. Used to determine incentive eligibility.',
  household_size_tooltip:
    'Used to determine incentive eligibility. Include all members of your household (spouse, dependents, etc.). Few to no incentives mention households larger than 8 members, so select 8 if your household size is 8 or larger.',
  'incentives.less': ' less',
  'incentives.more': '... more',
  'incentives.selectModel': 'Select Model',
  'incentives.selectTrim': 'Select Trim',
  'incentiveSort.aToZ': 'Alphabetical: A to Z',
  'incentiveSort.largest': 'Largest First',
  'incentiveSort.zToA': 'Alphabetical: Z to A',
  'input-zipcode-for-rate-comp-launch':
    'Used to determine incentive eligibility. Include all members of your household (spouse, dependents, etc.). Few to no incentives mention households larger than 8 members, so select 8 if your household size is 8 or larger.',
  install: 'INSTALL',
  kilometersShort: 'km',
  liveInResidenceState:
    'Live in a residence that receives electric service from Xcel Energy in {stateName}',
  low: 'Low',
  'matchScore.adjustment': 'Adjustment',
  'matchScore.budget': 'Budget',
  'matchScore.charging': 'Charging',
  'matchScore.maxScore': 'Max Score',
  'matchScore.popover':
    'Your Match Score is based on your selected preferences.',
  'matchScore.range': 'Range',
  'matchScore.seats': 'Seats',
  'matchScore.title': 'Match Score',
  'matchScore.totalScore': 'Total Score',
  'matchScore.yourScore': 'Your Score',
  medium: 'Medium',
  'miles-driven-annually-range_tooltip':
    "Based on the Department of Transportation's estimates of the average annual miles driven in 2020, a typical driver logs about 16,000 miles per year.",
  milesDrivenAnnually_tooltip: 'Based on the Department of Transportation',
  milesWord: 'Miles',
  modal1: 'What is the average electric charge on your monthly bill?',
  modal10: 'Tip: A typical driver logs about 12,000 miles per year.',
  modal11: 'Which charging timeframe suits you best?',
  modal12:
    'Tip: Charging at night (from 12-6 a.m.) is most cost-effective. You can program your EV to charge during the timeframe that suits you best.',
  modal13: 'All Hours',
  modal14: 'What is your current pricing plan?',
  modal15: 'Tip: Most customers are on TOU-DR1.',
  modal16:
    'Note: For customers on non-EV pricing plans (including DR, TOU-DR1 and DR-SES), we assume you currently drive a gas vehicle with a type, make and price similar to the EV selected  in Step 2 and show the savings from switching to this EV. For customers on the EV-TOU-5 pricing plan, we assume you already own the EV selected and show your current savings relative to non-EV pricing plans.',
  modal2: 'Step',
  modal3: 'of',
  modal4: 'Next',
  modal5: 'Which EV do you already own or want to buy/lease?',
  modal6: 'Tip: You can adjust these filters after you view your results.',
  modal7:
    'Choose your current or preferred EV to view potential savings on different pricing plans. Vehicle selection affects potential electric bill savings due to differences in electric performance and efficiency across models.',
  modal8: 'PREVIOUS',
  modal9: 'On average, how many miles per year do you drive?',
  'model.year': 'Model Year',
  month: 'month',
  monthWord: 'month',
  new: 'New',
  overTenYears: 'OVER 10 YEARS',
  phevFuelType: 'Plug in Hybrid',
  portionOfPublicCharging: 'Portion of Public Charging',
  portionOfPublicChargingTooltip:
    'If you can’t charge at home, you will need to charge at paid public charging stations. Estimate what percentage of EV charging time would be at paid public charging stations instead of at home.',
  'pre-owned': 'Pre-Owned',
  Preferredpartner: 'Preferred Partner',
  prefferedEvChargingTimeframe: 'PREFERRED EV CHARGING TIMEFRAME',
  prefferedEvChargingTimeframe_tooltip:
    'Charging at night (12-6 a.m.) is most cost-effective. You can program your EV to charge during the timeframe that suits you best.',
  prefferedEvMake: 'PREFFERED EV MAKE',
  prefferedEvMake_tooltip:
    'Note: We assume you currently drive a gas car of type, make, and price similar to those of the EV chosen.',
  prefferedEvModel: 'PREFFERED EV Model',
  'rateAdvisor.caption':
    'This Savings Calculator tool is provided for illustrative purposes. It is not a promise or guarantee that your actual charging costs will equal the costs shown in the tool. SDG&E does not guarantee the accuracy, completeness or usefulness of the estimated cost information. SDG&E expressly disclaims liability for any damages of any nature arising in connection with the use of the Savings Calculator tool. Your actual charging costs will vary based on a number of factors. “SDG&E” refers to San Diego Gas & Electric Company. ©2022 SDG&E. All rights reserved.',
  'rateAdvisor.pricingPlanComparison': 'Pricing Plan Comparison',
  'rateAdvisor.sub':
    'Identify your savings opportunities with an EV. Adjust the filters to see your savings.',
  'rateAdvisor.title': 'Savings Calculator',
  'rateComparison.youAreAlreadySaving':
    'You are already saving up to {highlightText} if you have an EV and use the {highlight} rate plan.',
  'rateComparison.youAreAlreadySavingVehicle':
    'You are already saving up to {highlightText} per year on {highlight} with a {selectedVehicle}.',
  'rateComparison.youAreSaving':
    'You are saving up to {highlightText} if you have an EV and use the {highlight} rate plan.',
  'rateComparison.youAreSavingVehicle':
    'You can save {highlightText} per year on {highlight} with a {selectedVehicle}.',
  rateDRSESParagraph1:
    'DR-SES is the plan for solar and other renewable energy customers.\n            Pricing is based on the time and day of the week, along with how much\n            electricity you use. You',
  rateDRSESParagraph2:
    'This plan could be a good fit for you if you generate renewable energy,\n            if you can shift your energy use activities to before 4 p.m. and after 9\n            p.m., and if you can take advantage of lower-priced electricity during\n            off-peak times.',
  rateEVTOU5Paragraph1:
    'The EV-TOU-5 plan is for customers to charge electric vehicles at home.\n            Pricing is based on how much electricity you use and when, with three\n            pricing periods. In exchange for a basic service fee, we offer our\n            lowest rates for overnight EV charging at home.',
  rateEVTOU5Paragraph2:
    'This plan could be a good fit if you can shift some of your electricity\n            use away from the on-peak hours of 4-9 p.m. and you can regularly charge\n            an electric vehicle during the super off-peak period late at night.',
  rateTOUDR1Paragraph1:
    'TOU-DR1 pricing is based on the amount of electricity you use, as well\n            as the time and day of the week you use it. With three pricing periods,\n            there’s an opportunity to save the most on nights and weekends.',
  rateTOUDR1Paragraph2:
    'This plan could be a good fit if you can shift some of your electricity\n            use away from the on-peak hours of 4-9 p.m. and you can take advantage\n            of lower-priced electricity during the off-peak times during nights and\n            weekends.',
  regularResidential: 'Regular Residential',
  saved: 'saved',
  'select-charger-level_tooltip':
    'More electric vehicles will be convenient for you if you can charge quickly at home.',
  savingsGraphDisclaimer:
    '* Assumes you power your home with this pricing plan and currently drive a gas vehicle with a type, make and price that is similar to the EV you selected.',
  savingsGraphEVLabel: 'Electric Vehicle',
  savingsGraphGasLabel: 'Gasoline',
  savingsGraphHomeLabel: 'Home',
  savingsGraphYAxis: 'Estimated average costs per year',
  trade_in_tooltip:
    'Retiring an old gas vehicle may be required for certain incentives.',
  trim: 'Trim',
  type_tooltip:
    'All-electric vehicles use electricity only. Plug-in hybrids can use electricity and gasoline.',
  Unfinished: 'Unfinished',
  updateZipcode: 'Update Zipcode',
  'vehicle.milesCapital': 'Miles',
  'vehicle.status': 'Vehicle Status',
  'vehicles.new': 'New',
  'vehicles.used': 'Used',
  'incentives.noneFound':
    'No incentives matched your current filters. Try broadening vehicle or eligibility filters.',
  vehicleType: 'Select all vehicle body types you are interested in.',
  viewSavings: 'VIEW SAVINGS',
  Website: 'Website',
  youAreEligible: 'You',
};

export default EN_CUSTOM;
